import { useTranslation } from "react-i18next";

const categoryData = [
  {
    nameKey: "category_shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Vibrant%20sneaker%20wall%20display%20with%20colorful%20athletic%20shoes%20arranged%20on%20white%20floating%20shelves%2C%20bright%20studio%20lighting%20from%20above%2C%20clean%20minimalist%20sneaker%20store%20aesthetic%2C%20fresh%20energetic%20mood%2C%20sage%20green%20accent%20wall%2C%20editorial%20footwear%20photography%2C%20crisp%20modern%20composition%2C%20high%20detail%20product%20shots&width=800&height=600&seq=cat-shoes-v3&orientation=landscape",
    isTop: true,
  },
  {
    nameKey: "category_hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodies%20hanging%20on%20warm%20wooden%20hangers%20against%20cream%20wall%2C%20soft%20afternoon%20light%20from%20side%20window%2C%20minimalist%20Scandinavian%20clothing%20display%2C%20neutral%20beige%20and%20warm%20taupe%20tones%2C%20clean%20editorial%20fashion%20photography%2C%20inviting%20relaxed%20atmosphere%2C%20textile%20texture%20visible&width=800&height=600&seq=cat-hoodies-v3&orientation=landscape",
    isTop: false,
  },
  {
    nameKey: "category_tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20cotton%20t-shirts%20in%20pastel%20colors%20neatly%20folded%20in%20stack%20on%20white%20marble%20surface%2C%20soft%20diffused%20morning%20light%2C%20minimalist%20clean%20fashion%20retail%20aesthetic%2C%20coral%20pink%20mint%20green%20and%20cream%20palette%2C%20editorial%20clothing%20photography%2C%20fresh%20modern%20composition%2C%20delicate%20fabric%20texture&width=800&height=600&seq=cat-tshirts-v3&orientation=landscape",
    isTop: false,
  },
  {
    nameKey: "category_jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20bomber%20and%20denim%20jackets%20displayed%20on%20minimalist%20brass%20clothing%20rack%2C%20natural%20window%20light%20casting%20soft%20shadows%2C%20modern%20boutique%20interior%2C%20warm%20terracotta%20and%20cream%20color%20palette%2C%20editorial%20fashion%20photography%2C%20sophisticated%20clean%20composition%2C%20subtle%20texture%20details&width=800&height=600&seq=cat-jackets-v3&orientation=landscape",
    isTop: false,
  },
  {
    nameKey: "category_pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Casual%20pants%20and%20tailored%20shorts%20neatly%20arranged%20on%20light%20oak%20surface%2C%20natural%20daylight%20from%20large%20window%2C%20minimalist%20fashion%20display%2C%20soft%20earth%20and%20sand%20tones%2C%20editorial%20clothing%20photography%2C%20clean%20modern%20aesthetic%2C%20fresh%20organized%20composition%2C%20fabric%20drape%20visible&width=800&height=600&seq=cat-pants-v3&orientation=landscape",
    isTop: false,
  },
  {
    nameKey: "category_headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Trendy%20caps%20beanies%20and%20bucket%20hats%20arranged%20on%20white%20acrylic%20display%20stands%2C%20soft%20studio%20lighting%2C%20minimalist%20accessory%20boutique%20display%2C%20warm%20neutral%20background%20with%20sage%20accents%2C%20editorial%20headwear%20photography%2C%20modern%20streetwear%20aesthetic%2C%20bright%20clean%20composition&width=800&height=600&seq=cat-headwear-v3&orientation=landscape",
    isTop: false,
  },
  {
    nameKey: "category_sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Coordinated%20matching%20fashion%20sets%20displayed%20on%20sleek%20minimalist%20mannequins%2C%20soft%20natural%20light%20from%20above%2C%20clean%20white%20studio%20background%20with%20subtle%20warm%20gradient%2C%20modern%20editorial%20style%2C%20elegant%20composition%2C%20fresh%20spring%20aesthetic%2C%20professional%20fashion%20photography%2C%20harmonious%20color%20blocking&width=800&height=600&seq=cat-sets-v3&orientation=landscape",
    isTop: false,
  },
  {
    nameKey: "category_underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20underwear%20and%20loungewear%20neatly%20folded%20on%20soft%20brushed%20cotton%20fabric%2C%20gentle%20morning%20light%20through%20sheer%20curtain%2C%20minimalist%20clean%20aesthetic%2C%20warm%20cream%20and%20blush%20tones%2C%20editorial%20product%20photography%2C%20fresh%20discreet%20composition%2C%20elegant%20simplicity%2C%20soft%20texture%20emphasis&width=800&height=600&seq=cat-underwear-v3&orientation=landscape",
    isTop: false,
  },
  {
    nameKey: "category_jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Sports%20jerseys%20displayed%20on%20white%20wall%20with%20dramatic%20side%20lighting%2C%20clean%20athletic%20aesthetic%2C%20modern%20sportswear%20retail%20display%2C%20dynamic%20composition%2C%20professional%20sports%20photography%20style%2C%20fresh%20energetic%20mood%2C%20subtle%20motion%20blur%20effect%2C%20bright%20crisp%20atmosphere&width=800&height=600&seq=cat-jersey-v3&orientation=landscape",
    isTop: false,
  },
  {
    nameKey: "category_accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Fashion%20accessories%20collection%20including%20watches%20jewelry%20and%20sunglasses%20on%20white%20ceramic%20tray%2C%20soft%20natural%20window%20light%2C%20minimalist%20flat%20lay%2C%20elegant%20composition%2C%20editorial%20product%20photography%2C%20warm%20neutral%20and%20sage%20green%20palette%2C%20refined%20sophisticated%20atmosphere%2C%20careful%20arrangement&width=800&height=600&seq=cat-accessories-v3&orientation=landscape",
    isTop: false,
  },
  {
    nameKey: "category_bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Designer%20bags%20and%20backpacks%20displayed%20on%20light%20travertine%20shelf%2C%20soft%20directional%20window%20light%2C%20minimalist%20luxury%20boutique%20display%2C%20elegant%20warm%20neutral%20background%2C%20editorial%20product%20photography%2C%20sophisticated%20clean%20aesthetic%2C%20refined%20composition%2C%20subtle%20texture%20highlights&width=800&height=600&seq=cat-bags-v3&orientation=landscape",
    isTop: false,
  },
  {
    nameKey: "category_belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20leather%20belts%20elegantly%20coiled%20on%20white%20marble%20surface%20with%20brass%20buckle%20details%2C%20soft%20directional%20side%20light%2C%20minimalist%20luxury%20display%2C%20warm%20cognac%20and%20tan%20tones%2C%20clean%20modern%20aesthetic%2C%20editorial%20accessories%20photography%2C%20refined%20sophisticated%20composition%2C%20leather%20grain%20texture&width=800&height=600&seq=cat-belts-v3&orientation=landscape",
    isTop: false,
  },
  {
    nameKey: "category_perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottles%20with%20colorful%20liquids%20on%20white%20travertine%20surface%2C%20soft%20diffused%20window%20light%2C%20minimalist%20luxury%20display%2C%20clean%20sophisticated%20aesthetic%2C%20warm%20amber%20and%20sage%20tones%2C%20editorial%20product%20photography%2C%20refined%20composition%2C%20airy%20bright%20atmosphere%2C%20glass%20reflection%20details&width=800&height=600&seq=cat-perfumes-v3&orientation=landscape",
    isTop: false,
  },
  {
    nameKey: "category_other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Curated%20miscellaneous%20lifestyle%20and%20fashion%20products%20on%20white%20desk%2C%20soft%20natural%20daylight%2C%20minimalist%20flat%20lay%2C%20eclectic%20organized%20display%2C%20warm%20neutral%20and%20sage%20green%20palette%2C%20editorial%20product%20photography%2C%20bright%20airy%20composition%2C%20harmonious%20arrangement&width=800&height=600&seq=cat-other-v3&orientation=landscape",
    isTop: false,
  },
];

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            {t("categories_title")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            {t("categories_subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categoryData.map((cat) => (
            <a
              key={cat.nameKey}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-xl overflow-hidden bg-background-100 cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={t(cat.nameKey)}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>

              <div className="p-3 md:p-4">
                <div className="flex items-center justify-between">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                    {t(cat.nameKey)}
                  </h3>
                  <span className="text-xs text-primary-600 opacity-0 group-hover:opacity-100 transition-all duration-300 group-hover:translate-x-0.5 transform whitespace-nowrap">
                    {t("category_discover")} →
                  </span>
                </div>
              </div>

              {cat.isTop && (
                <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-semibold bg-accent-500 text-white rounded-md whitespace-nowrap">
                  Top
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}